import { render, staticRenderFns } from "./BaggagePicker.vue?vue&type=template&id=a0f12318&scoped=true&"
import script from "./BaggagePicker.vue?vue&type=script&lang=js&"
export * from "./BaggagePicker.vue?vue&type=script&lang=js&"
import style0 from "./BaggagePicker.vue?vue&type=style&index=0&id=a0f12318&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f12318",
  null
  
)

export default component.exports